export enum InAppNotification {
  FACE_SCAN = 'face_scan',
  VOICE_SCAN = 'voice_scan',
  PERSONALISED_REPORT = 'personalised_report',
  LAB_REPORT = 'lab_report',
  SYMPTOM_CHECKER = 'symptom_checker',
  RISK_CHECKER = 'risk_checker',
  COMPLETE_HEALTH_PROFILE = 'complete_health_profile',
  ADD_PROFILE = 'add_profile',
  FAMILY_MEMBER = 'family_member',
  MISC = 'misc',
  MISCELLANEOUS = 'miscellaneous',
}
